<template>
  <div style="width:100%; height:100%;">
    <transition-group appear>
      <div v-for="filter in filters" :key="filter.key">
        <el-row type="flex" v-show="filter.show" align="middle" class="grid-content bg-title">
          <el-col style="min-width:160px">
            <div class="title-text">
              <!--svg-icon :icon-class="filter.icon" svg-class="svg-icon"></svg-icon-->
                <span class="title-span">{{filter.title}}</span>
            </div>
          </el-col>
          <el-col style="min-width:130px">
            <span class="title-span-selected" v-if="filter.show && filter.collapse && filter.value">{{filter.items.find(x=>x.value===filter.value).name}}</span>
          </el-col>
          <el-col >
            <div class="title-button">
              <el-button type="text" :icon="filter.collapse?'el-icon-plus':'el-icon-minus'" @click="filter.collapse=!filter.collapse"></el-button>
            </div>
          </el-col>
        </el-row>
        <div class="scroll-wrapper" v-show="!filter.collapse">
          <el-scrollbar class="scroll-list">
            <component :is="filter.component" :items="filter.items" :value="filter.value" @select="handleSelect($event, filter)" />
          </el-scrollbar>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'Dropper',
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    filterData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      filters: []
    }
  },
  methods: {
    handleSelect (val, filter) {
      this.$set(this.value, filter.key, val)
      this.$emit('input', this.value)
    }
  },
  mounted () {
    this.filters = this.filterData.map(filter => Object({
      title: filter.title,
      key: filter.key,
      show: filter.show,
      collapse: filter.collapse,
      component: filter.component,
      items: filter.items,
      value: filter.value
    }))
  },
  watch: {
    filterData: {
      handler (newVal) {
        this.filters = this.filterData.map(filter => Object({
          title: filter.title,
          key: filter.key,
          icon: filter.icon,
          show: filter.show,
          collapse: filter.collapse,
          component: filter.component,
          items: filter.items,
          value: filter.value
        }))
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.v-move {
  transition: all 0.3s;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.bg-title {
  background: #009844;
  margin-top: 20px;
}

.title-text {
  margin-left: 25px;
  color: white;
}

.title-span {
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 600;
}

.title-span-selected {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: white;
  font-weight: 400;
}

.title-button {
  float: right;
  margin-right: 20px;
}

.svg-icon {
  font-size: 20px;
}

a:link,
a:visited {
  text-decoration: none;
  color: inherit;
}
a:hover {
  color: #409eff;
}

.scroll-wrapper {
  max-height: 440px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
}

.scroll-list {
  overflow-y: auto;
  max-height: 340px;
  background: #f5f5f5;
}
.scroll-list .el-scrollbar__wrap {
  overflow: hidden;
}
.scroll-list .el-scrollbar__bar {
  opacity: unset;
}
.el-button--text, .el-button:focus, .el-button:hover{
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/Dropper.vue